export default __webpack_public_path__ + "static/media/cancel.e431828d.svg";